import { render, staticRenderFns } from "./FormDocumentsAdd.vue?vue&type=template&id=328e9674&lang=pug&"
import script from "./FormDocumentsAdd.vue?vue&type=script&lang=js&"
export * from "./FormDocumentsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports